import { j as m } from "../../../../react/jsx-runtime.es.es.js";
import { h as N, E as M, c as $ } from "../../dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../../hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../serialize/dist/emotion-serialize.browser.esm.es.es.js";
function f(s, r, t) {
  return N.call(r, "css") ? m.jsx(M, $(s, r), t) : m.jsx(s, r, t);
}
function e(s, r, t) {
  return N.call(r, "css") ? m.jsxs(M, $(s, r), t) : m.jsxs(s, r, t);
}
export {
  f as jsx,
  e as jsxs
};
//# sourceMappingURL=emotion-react-jsx-runtime.browser.esm.es.es.js.map
